import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './styles/global.scss';
import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, } from 'react-router-dom';
const HomePage = lazy(() => import('./pages/Home/Home'));
const basename = '/job-search-tools';
const App = () => {
    return (_jsxs("div", { className: 'job-search-tools', children: [_jsx("a", { className: 'sr-only', href: '#main-content', children: "Skip to main content" }), _jsx(BrowserRouter, { basename: basename, children: _jsx("main", { className: 'main', id: 'main-content', role: 'main', children: _jsx(Suspense, { fallback: _jsx("div", { className: 'ellipses', children: "Loading" }), children: _jsx(Routes, { children: _jsx(Route, { element: _jsx(HomePage, {}), path: '/' }) }) }) }) })] }));
};
export default App;
